<nav class="navbar campaign-header py-2" [style.background]="headerBackground">
  <div class="container d-flex align-items-center justify-content-between">
    <a class="header-logo-link">
      <img
        [src]="imageError ? defaultLogo : logoCampaign"
        alt="logo"
        class="img-logo"
        (error)="onErrorImage()"
      />
    </a>
    <div class="header-right-panel">
      <p class="header-text-right" [style.color]="headerTextColor">
        <span class="powered-by">Powered by</span>
        <strong class="brand-name">ShareWave</strong>
      </p>
    </div>
  </div>
</nav>
